import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "product-box" }
const _hoisted_2 = { class: "product-detail" }
const _hoisted_3 = { class: "product-img" }
const _hoisted_4 = { class: "view-box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "select-box" }
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = { class: "product-text" }
const _hoisted_9 = { class: "product-name" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "content" }

import { ref, onMounted } from 'vue'
import { getProductById } from '@/api'

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductDetail',
  setup(__props) {

const showPhone = ref(false)
const productData: any = ref({})
const activeImage = ref(0)

const activeImgEvent = (index: number) => {
  activeImage.value = index
}

const handleChange = (val: number) => {
  if ((activeImage.value == 0 && val < 0) || (activeImage.value == productData.value.picList.length - 1 && val > 0)) return
  activeImage.value += val
}

onMounted(() => {
  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  getProductById({ id: path.query?.id }).then((res: any) => {
    productData.value = { ...res };
    productData.value.productParameters = JSON.parse(res.productParameters || "{}")
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                style: _normalizeStyle({ left: -activeImage.value * 400 + 'rem' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productData.value.picList, (img, index) => {
                  return (_openBlock(), _createElementBlock("img", {
                    src: img,
                    key: index
                  }, null, 8, _hoisted_5))
                }), 128))
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (productData.value.picList?.length > 3)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "prev",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChange(-1)))
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productData.value.picList, (img, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(activeImage.value == index ? 'active-img' : '')
                }, [
                  _createElementVNode("img", {
                    src: img,
                    onClick: ($event: any) => (activeImgEvent(index))
                  }, null, 8, _hoisted_7)
                ], 2))
              }), 128)),
              (productData.value.picList?.length > 3)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "next",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChange(1)))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(productData.value.productName), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productData.value.productParameters, (e, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(i), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(e), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: "product-consultation",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showPhone.value = true), ["stop"]))
            }, "产品咨询")
          ])
        ])
      ])
    ]),
    (showPhone.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "product-consultation-model",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showPhone.value = false), ["stop"]))
        }, [
          _createElementVNode("div", {
            onClick: ($event: any) => (null)
          }, [
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("img", { src: "/images/phone-red.png" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(productData.value.contactInfo), 1)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", null, "详情请拨打咨询热线", -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})